export const BUYERS_OPTIONS = [
  {
    label: 'Wientjes verkoper',
    value: 1,
  }
];
